// extracted by mini-css-extract-plugin
export default {"button":"button-price_button__3sBGD"};